// extracted by mini-css-extract-plugin
export default {"searchWrapper":"CasinoGames_searchWrapper__TLsTc","searchInput":"CasinoGames_searchInput__DfMw3","cancelSearchIcon":"CasinoGames_cancelSearchIcon__XMw6s"};